import { Circle, LinearRing } from 'ol/geom';
import { intersects } from 'ol/extent';

function cross(a, b, o) {
  return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]);
}

/**
 * @param points An array of [X, Y] coordinates
 */
export const convexHull = function (points) {
  points.sort(function (a, b) {
    return a[0] == b[0] ? a[1] - b[1] : a[0] - b[0];
  });

  let lower = [];
  for (let i = 0; i < points.length; i++) {
    while (
      lower.length >= 2 &&
      cross(lower[lower.length - 2], lower[lower.length - 1], points[i]) <= 0
    ) {
      lower.pop();
    }
    lower.push(points[i]);
  }

  let upper = [];
  for (let i = points.length - 1; i >= 0; i--) {
    while (
      upper.length >= 2 &&
      cross(upper[upper.length - 2], upper[upper.length - 1], points[i]) <= 0
    ) {
      upper.pop();
    }
    upper.push(points[i]);
  }

  upper.pop();
  lower.pop();
  return lower.concat(upper);
};

export const makeRingFromExtent = (extent) => {
  return new LinearRing([
    [extent[0], extent[1]],
    [extent[0], extent[3]],
    [extent[2], extent[3]],
    [extent[2], extent[1]],
    [extent[0], extent[1]],
  ]);
};

/*
    @param possibilities: an array of objects like {'id': id, extent: extent (ol obj), point: p (ol obj), clustered: false}
    @param start -- index of start from the possibilities array.
 */
export let makeRingFromIntersections = (possibilities, start_idx = 0) => {
  console.log('iteration of making rings from intersections');
  let start = possibilities[start_idx];

  possibilities.forEach((d) => {
    if (d.clustered) return;
    if (d.id === start.id) d.clustered = true; // comparator is the same point. mark as clustered so we don't reattempt.
    if (intersects(start.extent, d.extent)) {
      d.clustered = true;
      start.clustered = true; //mark that we found an intersection
    }
  });

  let ring;
  if (start.clustered) {
    let coords = possibilities.map((d) => d.point.getGeometry().getCoordinates());
    ring = convexHull(coords);
    possibilities = possibilities.filter((d) => !d.clustered);
  } else {
    ring = makeRingFromExtent(start.extent);
    possibilities = possibilities.filter((d) => d.id === start.id);
  }

  return { unmatched_points: [...possibilities], ring };
};

//for points that are in the polygon but not selected, make enclaves in the polygon

export const createEnclaves = (poly, source, selectedPointIds) => {
  let extent = poly.getExtent();
  let enclavedPoints = [];

  source.forEachFeatureInExtent(extent, (e) => {
    console.log(e);
    if (
      !selectedPointIds.includes(e.get('id')) &&
      e.getGeometry().getType() === 'Point' &&
      poly.intersectsCoordinate(e.getGeometry().getCoordinates())
    ) {
      enclavedPoints.push(e);
    }
  });

  if (enclavedPoints.length <= 2) {
    enclavedPoints.forEach((p) => {
      let circle = new Circle(p.getGeometry().getCoordinates(), 60);
      let circle_extent = circle.getExtent();
      poly.appendLinearRing(makeRingFromExtent(circle_extent));
    });
  } else {
    let processing = [];

    enclavedPoints.forEach((p) => {
      let circle = new Circle(p.getGeometry().getCoordinates(), 50);
      let circle_extent = circle.getExtent();
      processing.push({ id: p.get('id'), extent: circle_extent, point: p, clustered: false });
    });

    let pass = makeRingFromIntersections(processing);
    let { ring, unmatched_points } = pass;
    processing = unmatched_points;
    poly.appendLinearRing(new LinearRing(ring));
  }
};
